import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import Services from "../../../../../API/LegalFormService";
import { useGlobalContext } from "../../../../../context/globalContext";
import { useLanguage } from "../../../../../hooks/useLanguage";
import { FormikInput } from "../../../../../shared/FormikFields/FormikInput";
import { Modal } from "./Modal";
import  "./modal.css"
import search from '../../../../../assets/icons/search.svg'


function SearchModal({ isOpen, onToggle }) {
    const { t, i18n } = useTranslation();
    const { GetLegalCountries } = Services;
    const [legalCountries, setLegalCountries] = useState([]);
    const [countries, setCountries] = useState([])
    const [loading, setLoading] = useState(true)
    const { catchError } =useGlobalContext();
    const {formatOptionsByLang} = useLanguage()
    const [keyword, setKeyword] = useState('');

useEffect(() => {
    async function callAPI () {
      const [
        legalCountriesFromAPI, 
      ] = await Promise.all([
        GetLegalCountries(), 
      ])
      .catch((err)=>{
        setLoading(false)
        catchError(err)
      })
      setCountries(formatOptionsByLang(legalCountriesFromAPI.data))
      if(legalCountriesFromAPI)
        setLoading(false)
    }
    callAPI()
  }, []);

useEffect(()=>{
    setLegalCountries(countries)
  },[countries])

const onChange = (keyword) => {
    setLegalCountries(
        countries.filter(countries => {
        return `${countries.label.toLowerCase()}`.includes(keyword.toLowerCase());
        })
    )
    
setKeyword(keyword);
    
 }

  return (
    <Modal isOpen={isOpen} toggle={onToggle}>
      <div className="w-full" >
            <h2 className="font-bold text-lg text-center my-6">{t('listOfCountries')}</h2>
           <FormikInput
                style={{
                  backgroundImage: `url("${search}")`,
                  backgroundRepeat: 'no-repeat',
                  backgroundPosition: '2%',
                  backgroundSize: '20px',
              }}
                inputStyles={{paddingLeft: '38px'}}
                placeholder={t('search')}
                value={keyword}
                onChange={(e) => onChange(e.target.value)}

                />
      </div>
      <div className="h-4/5 w-full overflow-auto text-start fade"> 
        {legalCountries.map((text) => 
        <p key={text.value}  className="text-sm pb-6 px-6 leading-relaxed break-words">{text.label}</p>
         )}  
      </div>

      
    </Modal>
  );
}

export { SearchModal };
